import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ILocation } from "../../models/interfaces/ILocation";
import { ITitle } from "../../models/interfaces/ITitle";
import "./CpntDataTable.scss";
import TableBodyItem from "./TableBodyItem";
import TableHeader from "./TableHeader";
import React from "react";
import HtmlRenderImageICon from "../../pages/FO/components/HtmlRender/HtmlRenderImageICon";
import { IToggleView } from "../../models/interfaces/IToggleView";
import HtmlRenderActionICon from "../../pages/FO/components/HtmlRender/HtmlRenderActionICon";


// Icônes SVG pour "Afficher" et "Masquer"
const ExpandIcon = () => (
  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 52 52">
<path d="M47.6,17.8L27.1,38.5c-0.6,0.6-1.6,0.6-2.2,0L4.4,17.8c-0.6-0.6-0.6-1.6,0-2.2l2.2-2.2
 c0.6-0.6,1.6-0.6,2.2,0l16.1,16.3c0.6,0.6,1.6,0.6,2.2,0l16.1-16.2c0.6-0.6,1.6-0.6,2.2,0l2.2,2.2C48.1,16.3,48.1,17.2,47.6,17.8z"
 />
</svg>
);

const CollapseIcon = () => (
  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 52 52" >
<path d="M4.4,34.2l20.5-20.7c0.6-0.6,1.6-0.6,2.2,0l20.5,20.7c0.6,0.6,0.6,1.6,0,2.2l-2.2,2.2
	c-0.6,0.6-1.6,0.6-2.2,0L27.1,22.2c-0.6-0.6-1.6-0.6-2.2,0L8.8,38.5c-0.6,0.6-1.6,0.6-2.2,0l-2.2-2.2C3.9,35.7,3.9,34.8,4.4,34.2z"
	/>
</svg>
);

export interface IProps {
  data: Record<string, any>[];
  dataHeader: ITitle[];
  dataItemsStyle?: Record<string, unknown>;
  link?: string;
  actions?: ILocation[];
  toggleview?: IToggleView,
  checkbox?:boolean,
  handleShow?: unknown;
  setCommandId?: unknown;
  onDelete?: unknown;
  sortDefault?: any;
  updateSorter?: (field: string) => void;
  updateDescending?: (value: boolean) => void; 
  actualFilterPage: string;
  onSelectionChange?: (selectedIds: string[]) => void;
}

const CpntDataTable: React.FC<IProps> = ({
  data,
  dataHeader,
  dataItemsStyle,
  toggleview,
  checkbox,
  actions,
  actualFilterPage,
  sortDefault,
  updateSorter,
  updateDescending,
  onSelectionChange,
  
}: IProps) => {
  const [columnFiltered, setColumnFiltered] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [sorter, setSorter] = useState<any>();
  const [expandedRowIds, setExpandedRowIds] = useState<number[]>([]);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({}); 

  const navigate = useNavigate();

  let columnsIndex: any = 0;
  if (data[0] && dataHeader) {
    columnsIndex = Object.keys(data[0]).map((key) =>
      dataHeader.findIndex((item) => item.Id === key)
    );
  }
  
  const titles: ITitle[] = Object.values(dataHeader);

  const handleToggle = (id: number) => {
    setExpandedRowIds(prevExpandedRowIds => {
      if (prevExpandedRowIds.includes(id)) {
        return prevExpandedRowIds.filter(rowId => rowId !== id);
      } else {
        return [...prevExpandedRowIds, id];
      }
    });
  };
  const handleCheckAll = () => {
    const updatedCheckedItems = data.reduce((acc, item) => {
      acc[item.Id] = !allChecked; 
      return acc;
    }, {} as Record<string, boolean>);
    
    setCheckedItems(updatedCheckedItems);
    setAllChecked(!allChecked);
  };

  const handleCheckItem = (id: string) => {
    const updatedCheckedItems = {
      ...checkedItems,
      [id]: !checkedItems[id], 
    };
    setCheckedItems(updatedCheckedItems);
    const allItemsChecked = data.every(item => updatedCheckedItems[item.Id]);
    setAllChecked(allItemsChecked); 
  };
  const getSelectedIds = () => {
    return Object.keys(checkedItems).filter(id => checkedItems[id]);
  };

  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(getSelectedIds());
    }
  }, [checkedItems, onSelectionChange]);
  return (
    <section id="no-more-tables">
      <Table className="table table-striped App-custom-table">
        <thead>
          <tr>
            {checkbox && (
              <>
              <th>
                <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleCheckAll}
                  />
              </th>
              </>
            )}
             {actions && actions.length > 0 && (
              <th><HtmlRenderActionICon /></th>
            )}
             {toggleview && (
              <th><HtmlRenderImageICon /></th>
            )}
            {columnsIndex && (
              <TableHeader
                updateDescending={updateDescending}
                updateSorter={updateSorter}
                actualFilterPage={actualFilterPage}
                titles={titles}
                columnsIndex={columnsIndex}
                sorter={sorter}
                setSorter={setSorter}
                setColumnFiltered={setColumnFiltered}
                setFilterValue={setFilterValue}
                possibleValues={data?.map(
                  (elem) =>
                    typeof columnFiltered === "string" && elem[columnFiltered]
                )}
              />
            )}
           
          </tr>
          
        </thead>

        <tbody className="t-body-datatable">  
          {data
            ?.filter((elem) => {
              if (columnFiltered && typeof columnFiltered === "string") {
                return elem[columnFiltered]
                  ?.toString()
                  .toLowerCase()
                  .includes(filterValue.toLowerCase());
              }
              return true;
            })
            ?.sort(sorter)
            ?.map((dataRow, i) => (
              <React.Fragment key={"fragment_" + dataRow.Id + "_" + i}>
              <tr key={"tr_" + dataRow.Id + "_" + i} className={checkedItems[dataRow.Id] ? "selected-row" : ""}>
              {checkbox && (
                    <td>
                     <input
                      type="checkbox"
                      checked={checkedItems[dataRow.Id] || false} 
                      onChange={() => handleCheckItem(dataRow.Id.toString())} 
                    />
                    </td>
                  )}
                
               
    
                  {actions && actions.length > 0 && (
                    <>
                    <td key={"td_actions_" + dataRow.Id + "_" + i} data-title={"Actions"}> {/*desktop-only-section*/ }
                    {/* className="text-center"  */}
                      <div 
                      className="actionFlexDirection"
                      style={{
                        //display: 'flex',
                        //flexDirection: "column",
                        gap: actions.some(Location => (typeof Location.ClassName === "function" ? Location.ClassName(i)?.includes("NotmultipleAction") : Location.ClassName?.includes("NotmultipleAction"))
                      ) ? '2px' : '0px',
                        //alignItems: 'center',
                        //lineHeight:'1',
                      }}>
                      {actions && 
                      actions.map((Location, j) => {
                      
                      const elemPathsName= typeof Location.PathsName === "function" ? Location.PathsName(i) : Location.PathsName;

                      const PathsNamekeys = Object.keys(elemPathsName || {})[0].toLowerCase();
                      const PathsNamevalue = Object.values(elemPathsName || {})[0].toLowerCase();

                      let _href = PathsNamevalue;
                      Object.keys(dataRow).forEach(
                        (key) =>
                          (_href = _href.replace(
                            "[[" + key.toLowerCase() + "]]",
                            dataRow[key]
                          ))
                      );

                      return (
                        <>
                          {Location.Visible && Location.Visible(i) === false ? <></> : (
                            
                            Location.ExternalLink ? (
                              // <span key={"tde_" + i + "_" + j}>
                              <a
                                key={"tde_" + i + "_" + j}
                                title={PathsNamekeys || ""}
                                target={Location?.Target}
                                //key={"a" + j}
                                className={typeof Location.ClassName === "function" ? Location.ClassName(i) : Location.ClassName}
                                href={_href}
                              >
                                &nbsp;
                              </a>
                              // </span>
                            ) : 
                            (
                              <i key={"tda_" + i + "_" + j}
                                style={{
                                  cursor: 'pointer',
                                  lineHeight:'1',
                                  //transition: 'background-color 0.3s ease',
                                  //lineHeight: '1',
                                  //verticalAlign: "text-bottom",
                                }}
                                title={PathsNamekeys || ""}
                                //key={"b" + j}
                                className={(typeof Location.ClassName === "function" ? Location.ClassName(i) : Location.ClassName) + " spanDatatable"}
                                onClick={() => {
                                  Location.ActionCallBack ? (Location.ActionCallBack(i) && navigate(_href)) : navigate(_href);
                                }}
                              >
                                &nbsp;
                              </i>
                            ))
                          }
                        </>
                      );
                    })}
                      </div>
                   
                    </td>
                      
                    </>
                  )}
                   {toggleview && (
                  <td className="desktop-only-section">
                  <button
                      onClick={() => handleToggle(dataRow.Id)}
                      style={{
                        background: 'none',
                        border: 'none',
                        padding: '0',
                        cursor: 'pointer',
                      }}
                    >
                      {expandedRowIds.includes(i) ? <CollapseIcon /> : <ExpandIcon />}
                  </button>
                  </td>
                )}
                   <TableBodyItem
                    item={dataRow}
                    keyitem={"tb" + dataRow.Id + "_" + i}
                    titles={titles}
                    columnsIndex={columnsIndex || []}
                    dataItemsStyle={dataItemsStyle}
                  />
                  
                </tr>
                {expandedRowIds.includes(dataRow.Id) && toggleview && (
                <tr className={checkedItems[dataRow.Id] ? "selected-row" : ""}>
                  <td colSpan={columnsIndex.length + 1}>
                    <div className="row">
                    <div className="col-2 pae-detail-label">
                        {toggleview?.ToggleImageFieldName && dataRow?.[toggleview.ToggleImageFieldName] ? (
                          <img
                            src={dataRow?.[toggleview.ToggleImageFieldName]}
                            className="img-notice-size"
                            alt="Couverture"
                          />
                        ) : (
                          <svg
                            style={{ backgroundColor: "#dee2e6" }}
                            width="100"
                            height="150"
                            version="1.1"
                            viewBox="0 0 240 240"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M20,170H220.78v20H20Zm200.78,60H30.43A10.42,10.42,0,0,1,20,219.53V210H220.78ZM20,149.81c0-13.06,3.74-29,29.91-33.64C80.58,110.69,214.25,69.48,220.78,2.26,223.58,76,105,143.28,20,149.81Z"></path>
                          </svg>
                        )}
                      </div>
                      {toggleview?.ToggleTextFieldName && dataRow?.[toggleview.ToggleTextFieldName] && (
                        <div className="col-8 pae-detail-label d-flex align-items-center p-3">
                        {dataRow?.[toggleview.ToggleTextFieldName]}
                      </div>
                      )}
                      
                    </div>
                  </td>
                </tr>
              )}


             </React.Fragment>
                

            ))}
        </tbody>
      </Table>
    </section>
     
  );
 
};

export default CpntDataTable;
